import { AbstractControl } from "@angular/forms";
import { Subscription } from "rxjs";

export type PdvFeeAbsorptionField =
  | "soldAtPdv"
  | "batchStartDate"
  | "absorbsPlatformFee"
  | "absorbsProcessingFee";

export type PdvFeeAbsorptionControls = {
  absorbsPlatformFee: AbstractControl<boolean | null>;
  absorbsProcessingFee: AbstractControl<boolean | null>;
  soldAtPdv: AbstractControl<boolean | null>;
  batchStartDate: AbstractControl<Date | string | null>;
  eventStartDate: string;
};

/**
 * Mantido como adaptador temporário para os dois formulários existentes.
 * As opções de absorção pertencem exclusivamente ao checkout web e não podem
 * habilitar/desabilitar o canal PDV. `pdv_only` é derivado pelo backend.
 */
export function applyPdvFeeAbsorptionSync(
  controls: PdvFeeAbsorptionControls,
  changed: PdvFeeAbsorptionField,
): void {
  void controls;
  void changed;
}

export function bindPdvFeeAbsorptionSync(
  controls: PdvFeeAbsorptionControls,
): Subscription {
  void controls;
  return new Subscription();
}
